import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import AdvisorsSection from "@components/Pages/Advisors/AdvisorsSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import AdvisorsData from "@jsons/advisors.json"
import React from "react"

type Props = {}

const management = (props: Props): JSX.Element => {
	const AdvancedSideAsset = getTranslatedPageData(AdvisorsData, true, true)
	const list = getValueOrThrow(AdvancedSideAsset.AdvancedSideAsset)

	return (
		<>
			<HeadMeta meta={AdvancedSideAsset.metaData} />

			<FullWidthHeader
				data={getValueOrThrow(list?.[0].mainContent)[0]}
				position={"left"}
				size={"L"}
			/>
			<AdvisorsSection data={getValueOrThrow(list[1]?.mainContent)} />
		</>
	)
}

export default management
